import { useEffect } from "react";
import { compute } from "compute-scroll-into-view";
import { useHandler } from "./use-handler.es.js";
function useScrollIntoView(scrollRef = {}, viewRef = {}, options = {}) {
  const { direction = "vertical", offset = 4 } = options;
  const scrollIntoView = useHandler(() => {
    if (!viewRef.current) {
      return;
    }
    const actions = compute(viewRef.current, {
      block: "nearest",
      boundary: scrollRef.current,
      scrollMode: "if-needed"
    });
    actions.forEach(({ el, left, top }) => {
      if (direction === "horizontal") {
        const movement = left > el.scrollLeft ? 1 : -1;
        el.scrollLeft = Math.max(0, left + offset * movement);
      } else {
        const movement = top > el.scrollTop ? 1 : -1;
        el.scrollTop = Math.max(0, top + offset * movement);
      }
    });
  });
  useEffect(() => {
    scrollIntoView();
  }, [scrollIntoView, viewRef.current]);
  return scrollIntoView;
}
export {
  useScrollIntoView
};
